module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-year-2025-aa8b16bec1a125d8306996c5ba1152a3.svg";